import { Link } from 'react-router-dom';

import classes from './VendorIcons.module.css';

import LogoImage from './LogoImage.jsx';

function VendorIcons({vendors}) {

  return (
    <div className={classes.vendor}>
      <ul className={classes.list}>
        {vendors.map((vendor) => (
          <li key={vendor.id} className={`${vendor.preferred ? classes.preferred : classes.item }`}>
            <Link to={vendor.website}>
              <LogoImage
                title={vendor.title}
                logo_contents={vendor.logo_contents}
                logo_filetype={vendor.logo_filetype}
                url={vendor.website}
              />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default VendorIcons;
